import React, { ChangeEvent, useCallback, useState } from "react";
import { AppDispatch } from "../../..";
import { officeApi } from "../../../api/config";
import { Fileread } from "../../../lib/lib";
import { CertifiFileType, CertifiUpload } from "../../../reducers/data";

type Props = {
  __cancel: () => void;
  dispatch: AppDispatch;
  data: {
    url: string;
    apply_id: string;
    prjt_id: string;
    rcrt_id: string;
  };
};

/** 파일 업로드 팝업 */
const FilePopup = ({
  __cancel,
  dispatch,
  data: { url, apply_id, prjt_id, rcrt_id },
}: Props) => {
  const [isError, setIsError] = useState<boolean>(false);
  const [File, setFile] = useState<File | undefined>(undefined);

  /** 파일 통신 함수 */
  const UpdateFile = useCallback(() => {
    if (File) {
      const form = new FormData();
      form.append("file", File);
      officeApi
        .post(
          `/cstm/prjt/${prjt_id}/rcrt/${rcrt_id}/apply/${apply_id}/cert`,
          form
        )
        .then(({ data: { sts_fg } }) => {
          if (sts_fg) {
            dispatch(CertifiUpload());
            __cancel();
          }
        });
    } else {
      setIsError(true);
    }
  }, [File, dispatch, apply_id, prjt_id, rcrt_id]);

  return (
    <div className="cert-file-popup">
      <div className="title">파일 업로드</div>
      {isError && !File ? (
        <div className="file-error-msg">파일을 업로드해주세요</div>
      ) : undefined}
      <label className={`file-label ${File ? "file-on" : ""}`}>
        {File ? (
          <>
            <img src="/assets/popup/active-document.svg" alt="" />
            <div className="text">{File.name}</div>
          </>
        ) : (
          <>
            <img src="/assets/popup/file-upload.svg" alt="" />
            <div className="text">파일을 선택 또는 드래그해주세요</div>
          </>
        )}
        <input
          type="file"
          style={{ display: "none" }}
          onChange={(e) => {
            if (e.target.files) {
              setFile(e.target.files[0]);
            }
          }}
        />
      </label>
      <button className="file-insert-btn" onClick={UpdateFile}>
        등록하기
      </button>
    </div>
  );
};

export default FilePopup;
